.filters {
  margin-bottom: 16px;
  row-gap: 12px;
}

.batchBar {
  margin-bottom: 16px;
}

.muted {
  color: var(--ant-color-text-tertiary);
}

.rowAudio {
  width: 200px;
  height: 32px;
}

.section {
  margin-bottom: 32px;
}

.mono {
  font-family: Monaco, Menlo, 'Ubuntu Mono', monospace;
  font-size: 12px;
}

.textBlock {
  max-height: 200px;
  padding: 8px;
  margin: 0;
  overflow-y: auto;
  font-size: 12px;
  word-break: break-all;
  white-space: pre-wrap;
  background: var(--ant-color-fill-tertiary);
  border-radius: var(--ant-border-radius-sm);
}

.detailAudio {
  width: 100%;
}

.breakAll {
  word-break: break-all;
}

/* 浏览器原生播放器跟随 <html data-theme> 切换明暗 */
:global(html[data-theme='dark']) .rowAudio,
:global(html[data-theme='dark']) .detailAudio {
  color-scheme: dark;
}
